// ─── SCHEDULING & ACCESS MOCK DATA ───────────────────────────────────────────
// Mock data for NX-007 Scheduling and Access domain

// FSA.2 L1 — Manager Overview (4 KPI cards + next available + provider availability + summaries)
export const mockSchedulingOverview = {
  // Card 1: Same-Day Access Rate
  sameDayRate: 78,
  sameDayTarget: 85,
  sameDayTrend: -3, // vs last week
  sameDayThisWeek: 156,
  // Card 2: Average Wait Time
  avgWaitDays: 4.2,
  waitTarget: 3,
  waitTrend: 0.5, // increasing = bad
  // Card 3: Open Slots Today
  openSlots: 23,
  providerCount: 9,
  // Card 4: Backlog
  backlog: 47,
  oldestRequestDays: 12,
  // Next Available by Care Type
  nextAvailable: {
    primaryCare: 3.1,
    specialty: 6.8,
    urgent: 0.5,
  },
  // Provider Availability Today (sorted by openSlots ascending)
  providerAvailability: [
    { id: 'p1', name: 'Dr. Sarah Johnson', specialty: 'Primary Care', openSlots: 0, totalSlots: 16 },
    { id: 'p2', name: 'Dr. Michael Chen', specialty: 'Cardiology', openSlots: 1, totalSlots: 12 },
    { id: 'p3', name: 'Dr. Lisa Patel', specialty: 'Primary Care', openSlots: 2, totalSlots: 14 },
    { id: 'p4', name: 'Dr. James Okafor', specialty: 'Oncology', openSlots: 3, totalSlots: 10 },
    { id: 'p5', name: 'Dr. Emily Davis', specialty: 'Primary Care', openSlots: 4, totalSlots: 16 },
    { id: 'p6', name: 'Dr. Robert Kim', specialty: 'Dermatology', openSlots: 5, totalSlots: 8 },
    { id: 'p7', name: 'NP Amanda Torres', specialty: 'Primary Care', openSlots: 6, totalSlots: 14 },
    { id: 'p8', name: 'Dr. David Park', specialty: 'Orthopedics', openSlots: 7, totalSlots: 12 },
    { id: 'p9', name: 'NP Rachel Simmons', specialty: 'Primary Care', openSlots: 8, totalSlots: 14 },
  ],
  // No-Show Summary (L1 card)
  noShowRate: 12.4,
  noShowTarget: 10,
  noShowTrend: 1.2,
  noShowRevenueLoss: 8400,
  lateCancellations: 8,
  reEngagementRate: 62,
  // Phone & Portal Summary (L1 card)
  phoneAbandonmentRate: 8.3,
  phoneAbandonmentTarget: 7,
  portalAdoptionRate: 34,
  abandonmentRevenueLoss: 12500,
  // Referral Aging Summary (L1 card)
  referralBuckets: { '0-7': 24, '8-14': 12, '15-30': 8, '30+': 5 },
  referralTotal: 49,
  // Data freshness
  lastUpdated: '2026-04-12T08:30:00Z',
};

// FSA.2 L2 — Capacity Analysis
export const mockCapacityAnalysis = {
  // Utilization by provider
  providerUtilization: [
    { id: 'p1', name: 'Dr. Sarah Johnson', specialty: 'Primary Care', location: 'Main Campus', utilization: 100, slots: 16, filled: 16 },
    { id: 'p2', name: 'Dr. Michael Chen', specialty: 'Cardiology', location: 'Main Campus', utilization: 92, slots: 12, filled: 11 },
    { id: 'p3', name: 'Dr. Lisa Patel', specialty: 'Primary Care', location: 'North Clinic', utilization: 86, slots: 14, filled: 12 },
    { id: 'p4', name: 'Dr. James Okafor', specialty: 'Oncology', location: 'Cancer Center', utilization: 70, slots: 10, filled: 7 },
    { id: 'p5', name: 'Dr. Emily Davis', specialty: 'Primary Care', location: 'Main Campus', utilization: 75, slots: 16, filled: 12 },
    { id: 'p6', name: 'Dr. Robert Kim', specialty: 'Dermatology', location: 'North Clinic', utilization: 38, slots: 8, filled: 3 },
    { id: 'p7', name: 'NP Amanda Torres', specialty: 'Primary Care', location: 'East Clinic', utilization: 57, slots: 14, filled: 8 },
    { id: 'p8', name: 'Dr. David Park', specialty: 'Orthopedics', location: 'Main Campus', utilization: 42, slots: 12, filled: 5 },
    { id: 'p9', name: 'NP Rachel Simmons', specialty: 'Primary Care', location: 'East Clinic', utilization: 43, slots: 14, filled: 6 },
  ],
  // Utilization by location
  locationUtilization: [
    { location: 'Main Campus', utilization: 78, providers: 4, slots: 56, filled: 44 },
    { location: 'North Clinic', utilization: 68, providers: 2, slots: 22, filled: 15 },
    { location: 'East Clinic', utilization: 50, providers: 2, slots: 28, filled: 14 },
    { location: 'Cancer Center', utilization: 70, providers: 1, slots: 10, filled: 7 },
  ],
  // Heatmap: day x provider (next 7 days, values = open slots)
  slotHeatmap: {
    days: ['Mon 4/13', 'Tue 4/14', 'Wed 4/15', 'Thu 4/16', 'Fri 4/17'],
    providers: ['Johnson', 'Chen', 'Patel', 'Okafor', 'Davis', 'Kim', 'Torres', 'Park', 'Simmons'],
    data: [
      [0, 1, 2, 3, 1], [1, 0, 2, 1, 2], [2, 3, 1, 2, 3], [3, 2, 4, 2, 3],
      [4, 3, 2, 5, 4], [5, 4, 6, 3, 5], [6, 5, 4, 7, 6], [7, 6, 5, 4, 7], [8, 7, 6, 8, 5],
    ],
  },
  // 4-week utilization trend
  utilizationTrend: [
    { week: 'W1 (3/16)', utilization: 72 },
    { week: 'W2 (3/23)', utilization: 74 },
    { week: 'W3 (3/30)', utilization: 68 },
    { week: 'W4 (4/6)', utilization: 71 },
  ],
  // Revenue impact
  avgRevenuePerVisit: 150,
  unfilledSlots: 35,
  revenueLeakage: 5250,
  // Alerts
  varianceAlert: true, // >25pt gap between providers
  lowUtilizationAlert: false, // <80% for 3 consecutive days
  lowUtilizationDays: 0,
};

// FSA.3 L1 — No-Show Summary (also embedded in overview, but separate endpoint for refresh)
export const mockNoShowSummary = {
  rate: 12.4,
  priorRate: 11.2,
  trend: 1.2,
  target: 10,
  revenueImpact: 8400,
  lateCancellations: 8,
  lateCancelWindow: 24, // hours
  reEngagementRate: 62,
  alertActive: true,
};

// FSA.3 L2 — No-Show Intelligence (all breakdowns)
export const mockNoShowIntelligence = {
  byProvider: [
    { id: 'p1', name: 'Dr. Sarah Johnson', rate: 15.2, appointments: 320, noShows: 49 },
    { id: 'p4', name: 'Dr. James Okafor', rate: 14.1, appointments: 180, noShows: 25 },
    { id: 'p3', name: 'Dr. Lisa Patel', rate: 11.8, appointments: 280, noShows: 33 },
    { id: 'p5', name: 'Dr. Emily Davis', rate: 10.5, appointments: 300, noShows: 32 },
    { id: 'p2', name: 'Dr. Michael Chen', rate: 8.2, appointments: 240, noShows: 20 },
    { id: 'p6', name: 'Dr. Robert Kim', rate: 7.5, appointments: 160, noShows: 12 },
  ],
  byVisitType: [
    { type: 'New Patient', rate: 16.8, count: 45 },
    { type: 'Follow-Up', rate: 11.2, count: 89 },
    { type: 'Procedure', rate: 8.5, count: 22 },
    { type: 'Wellness', rate: 6.3, count: 15 },
  ],
  byDayTime: {
    days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
    hours: ['8am', '9am', '10am', '11am', '12pm', '1pm', '2pm', '3pm', '4pm'],
    data: [
      [22, 14, 10, 8, 6, 9, 11, 13, 18],
      [18, 12, 9, 7, 5, 8, 10, 12, 16],
      [15, 10, 8, 6, 5, 7, 9, 11, 14],
      [20, 13, 11, 7, 6, 8, 10, 14, 17],
      [24, 16, 12, 9, 7, 10, 13, 15, 20],
    ],
  },
  byGeography: [
    { zip: '90210', rate: 18.5, distance: '30+', patients: 45 },
    { zip: '90001', rate: 16.2, distance: '21-30', patients: 120 },
    { zip: '90045', rate: 14.8, distance: '11-20', patients: 85 },
    { zip: '90034', rate: 12.1, distance: '11-20', patients: 200 },
    { zip: '90024', rate: 9.5, distance: '0-10', patients: 350 },
    { zip: '90025', rate: 8.8, distance: '0-10', patients: 280 },
    { zip: '90064', rate: 7.2, distance: '0-10', patients: 190 },
  ],
  byPayer: [
    { payer: 'Medicaid', rate: 18.5, count: 52, label: 'Transportation assistance, flexible scheduling recommended' },
    { payer: 'Self-Pay', rate: 15.8, count: 28, label: 'Financial counseling, sliding scale communication recommended' },
    { payer: 'Medicare', rate: 11.2, count: 34, label: 'Transportation and appointment reminder support recommended' },
    { payer: 'Commercial', rate: 7.8, count: 42, label: 'Standard reminder protocol' },
    { payer: 'Value-Based', rate: 6.5, count: 15, label: 'Care coordinator follow-up protocol' },
  ],
  byAgeCohort: [
    { cohort: '18-30', rate: 19.2, count: 38, supportNeeded: 'Digital engagement, flexible scheduling, text reminders' },
    { cohort: '31-45', rate: 13.5, count: 45, supportNeeded: 'Childcare support, evening/weekend availability' },
    { cohort: '46-60', rate: 10.8, count: 42, supportNeeded: 'Work schedule accommodation, telehealth options' },
    { cohort: '61-75', rate: 8.2, count: 30, supportNeeded: 'Transportation assistance, caregiver coordination' },
    { cohort: '75+', rate: 11.5, count: 16, supportNeeded: 'Transportation, caregiver coordination, home visit alternatives' },
  ],
  chronic: {
    reEngaged: [
      { patientId: 'PT-001', name: 'Patient A', noShows: 3, lastNoShow: '2026-03-15', rescheduled: '2026-03-22', payer: 'Medicaid', zip: '90001' },
      { patientId: 'PT-002', name: 'Patient B', noShows: 2, lastNoShow: '2026-03-20', rescheduled: '2026-04-01', payer: 'Medicare', zip: '90045' },
    ],
    atRisk: [
      { patientId: 'PT-003', name: 'Patient C', noShows: 4, lastNoShow: '2026-03-01', daysSinceLastVisit: 42, payer: 'Medicaid', zip: '90210' },
      { patientId: 'PT-004', name: 'Patient D', noShows: 3, lastNoShow: '2026-02-15', daysSinceLastVisit: 56, payer: 'Self-Pay', zip: '90001' },
      { patientId: 'PT-005', name: 'Patient E', noShows: 2, lastNoShow: '2026-03-10', daysSinceLastVisit: 33, payer: 'Medicaid', zip: '90045' },
    ],
  },
  trend12Week: [
    { week: 'W1', rate: 10.2 }, { week: 'W2', rate: 10.5 }, { week: 'W3', rate: 11.0 },
    { week: 'W4', rate: 10.8 }, { week: 'W5', rate: 11.5 }, { week: 'W6', rate: 11.2 },
    { week: 'W7', rate: 11.8 }, { week: 'W8', rate: 12.0 }, { week: 'W9', rate: 11.5 },
    { week: 'W10', rate: 12.2 }, { week: 'W11', rate: 12.0 }, { week: 'W12', rate: 12.4 },
  ],
};

// FSA.4 — Access Lag & Wait Time
export const mockAccessLag = {
  byVisitType: [
    { type: 'New Patient', avgDays: 18, medianDays: 15, benchmark: 14, trend: 'worsening' },
    { type: 'Follow-Up', avgDays: 8, medianDays: 6, benchmark: 7, trend: 'stable' },
    { type: 'Urgent/Same-Day', avgDays: 0.5, medianDays: 0, benchmark: 1, trend: 'improving' },
  ],
  byProvider: [
    { id: 'p1', name: 'Dr. Sarah Johnson', avgDays: 22, benchmark: 14, visitType: 'New Patient' },
    { id: 'p2', name: 'Dr. Michael Chen', avgDays: 28, benchmark: 20, visitType: 'New Patient' },
    { id: 'p3', name: 'Dr. Lisa Patel', avgDays: 12, benchmark: 14, visitType: 'New Patient' },
    { id: 'p4', name: 'Dr. James Okafor', avgDays: 15, benchmark: 20, visitType: 'New Patient' },
    { id: 'p5', name: 'Dr. Emily Davis', avgDays: 10, benchmark: 14, visitType: 'New Patient' },
  ],
  trend12Week: [
    { week: 'W1', newPatient: 16, followUp: 7, urgent: 0.3 },
    { week: 'W2', newPatient: 16.5, followUp: 7.2, urgent: 0.4 },
    { week: 'W3', newPatient: 17, followUp: 7.5, urgent: 0.3 },
    { week: 'W4', newPatient: 17.2, followUp: 7.8, urgent: 0.5 },
    { week: 'W5', newPatient: 17.5, followUp: 7.5, urgent: 0.4 },
    { week: 'W6', newPatient: 17, followUp: 8.0, urgent: 0.3 },
    { week: 'W7', newPatient: 17.8, followUp: 8.2, urgent: 0.5 },
    { week: 'W8', newPatient: 18, followUp: 8.0, urgent: 0.4 },
    { week: 'W9', newPatient: 17.5, followUp: 7.8, urgent: 0.5 },
    { week: 'W10', newPatient: 18.2, followUp: 8.0, urgent: 0.4 },
    { week: 'W11', newPatient: 17.8, followUp: 8.2, urgent: 0.5 },
    { week: 'W12', newPatient: 18, followUp: 8.0, urgent: 0.5 },
  ],
  benchmarks: { primaryCare: 14, specialtyNewPatient: 20, urgent: 1 },
  alertActive: true, // new patient lag >50% above benchmark
};

// FSA.5 — Open Referral Aging
export const mockReferralAging = {
  buckets: { '0-7': 24, '8-14': 12, '15-30': 8, '30+': 5 },
  total: 49,
  trend8Week: [
    { week: 'W1', total: 38, avgAge: 9.2 }, { week: 'W2', total: 40, avgAge: 9.8 },
    { week: 'W3', total: 42, avgAge: 10.1 }, { week: 'W4', total: 44, avgAge: 10.5 },
    { week: 'W5', total: 43, avgAge: 10.3 }, { week: 'W6', total: 45, avgAge: 11.0 },
    { week: 'W7', total: 47, avgAge: 11.5 }, { week: 'W8', total: 49, avgAge: 12.1 },
  ],
  referrals: [
    { id: 'R001', patientName: 'Gloria Reyes', referringProvider: 'Dr. Martinez', referredTo: 'Oncology / Dr. Okafor', referralDate: '2026-02-28', daysOutstanding: 43, authStatus: 'expired', bucket: '30+' },
    { id: 'R002', patientName: 'David Chen', referringProvider: 'Dr. Johnson', referredTo: 'Urology / Dr. Lee', referralDate: '2026-03-05', daysOutstanding: 38, authStatus: 'approved', bucket: '30+' },
    { id: 'R003', patientName: 'Maria Lopez', referringProvider: 'Dr. Patel', referredTo: 'Cardiology / Dr. Chen', referralDate: '2026-03-10', daysOutstanding: 33, authStatus: 'pending', bucket: '30+' },
    { id: 'R004', patientName: 'James Wilson', referringProvider: 'Dr. Davis', referredTo: 'Orthopedics / Dr. Park', referralDate: '2026-03-15', daysOutstanding: 28, authStatus: 'approved', bucket: '15-30' },
    { id: 'R005', patientName: 'Susan Brown', referringProvider: 'Dr. Johnson', referredTo: 'Dermatology / Dr. Kim', referralDate: '2026-03-20', daysOutstanding: 23, authStatus: 'none', bucket: '15-30' },
    { id: 'R006', patientName: 'Robert Taylor', referringProvider: 'Dr. Patel', referredTo: 'Cardiology / Dr. Chen', referralDate: '2026-03-28', daysOutstanding: 15, authStatus: 'pending', bucket: '15-30' },
    { id: 'R007', patientName: 'Linda Anderson', referringProvider: 'Dr. Davis', referredTo: 'Primary Care / NP Torres', referralDate: '2026-04-01', daysOutstanding: 11, authStatus: 'approved', bucket: '8-14' },
    { id: 'R008', patientName: 'Michael Garcia', referringProvider: 'Dr. Chen', referredTo: 'Oncology / Dr. Okafor', referralDate: '2026-04-03', daysOutstanding: 9, authStatus: 'pending', bucket: '8-14' },
    { id: 'R009', patientName: 'Jennifer White', referringProvider: 'NP Simmons', referredTo: 'Dermatology / Dr. Kim', referralDate: '2026-04-08', daysOutstanding: 4, authStatus: 'none', bucket: '0-7' },
    { id: 'R010', patientName: 'Thomas Martin', referringProvider: 'Dr. Johnson', referredTo: 'Orthopedics / Dr. Park', referralDate: '2026-04-10', daysOutstanding: 2, authStatus: 'approved', bucket: '0-7' },
  ],
  expiringAuth: [
    { id: 'R001', patientName: 'Gloria Reyes', authExpires: '2026-03-15', daysUntilExpiry: -28 },
    { id: 'R003', patientName: 'Maria Lopez', authExpires: '2026-04-20', daysUntilExpiry: 8 },
  ],
};

// FSA.6 — Phone & Portal
export const mockPhonePortal = {
  phone: {
    abandonmentRate: 8.3,
    abandonmentTarget: 7,
    avgHoldTimeSeconds: 142,
    callVolume: 385,
    callsHandled: 353,
    callsAbandoned: 32,
    revenueImpact: 4800,
    avgRevenuePerAppt: 150,
    peakHours: {
      hours: ['7am', '8am', '9am', '10am', '11am', '12pm', '1pm', '2pm', '3pm', '4pm', '5pm'],
      days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      data: [
        [12, 45, 62, 48, 35, 18, 42, 55, 38, 22, 8],
        [10, 40, 58, 45, 32, 15, 38, 50, 35, 20, 6],
        [8, 35, 52, 42, 30, 14, 35, 48, 32, 18, 5],
        [11, 42, 60, 46, 34, 16, 40, 52, 36, 21, 7],
        [15, 50, 68, 52, 38, 20, 45, 58, 40, 25, 10],
      ],
    },
    trend: [
      { week: 'W1', rate: 7.1 }, { week: 'W2', rate: 7.5 }, { week: 'W3', rate: 7.8 },
      { week: 'W4', rate: 8.0 }, { week: 'W5', rate: 7.9 }, { week: 'W6', rate: 8.1 },
      { week: 'W7', rate: 8.0 }, { week: 'W8', rate: 8.3 },
    ],
  },
  portal: {
    adoptionRate: 34,
    portalBookings: 132,
    phoneBookings: 253,
    totalBookings: 385,
    adoptionTrend: 'declining',
    trend: [
      { week: 'W1', portal: 38, phone: 62 }, { week: 'W2', portal: 37, phone: 63 },
      { week: 'W3', portal: 36, phone: 64 }, { week: 'W4', portal: 35, phone: 65 },
      { week: 'W5', portal: 35, phone: 65 }, { week: 'W6', portal: 34, phone: 66 },
      { week: 'W7', portal: 34, phone: 66 }, { week: 'W8', portal: 34, phone: 66 },
    ],
  },
  alertActive: true, // abandonment > 7%
  portalAlertActive: true, // below baseline 2+ weeks
};

// FSA.7 — Prior Auth Scheduling Impact
export const mockPriorAuth = {
  authPendingCount: 28,
  scheduledVolume: 245,
  authPendingPercent: 11.4,
  alertActive: true, // >10%
  byPayer: [
    { payer: 'UnitedHealthcare', pending: 8, avgTurnaroundDays: 12, above_average: true },
    { payer: 'Aetna', pending: 6, avgTurnaroundDays: 9, above_average: true },
    { payer: 'Blue Cross', pending: 5, avgTurnaroundDays: 6, above_average: false },
    { payer: 'Cigna', pending: 4, avgTurnaroundDays: 7, above_average: false },
    { payer: 'Humana', pending: 3, avgTurnaroundDays: 14, above_average: true },
    { payer: 'Medicare', pending: 2, avgTurnaroundDays: 5, above_average: false },
  ],
  byProcedure: [
    { procedure: 'MRI', pending: 10, rate: 18.5 },
    { procedure: 'CT Scan', pending: 6, rate: 12.2 },
    { procedure: 'Surgery Consult', pending: 5, rate: 15.0 },
    { procedure: 'Infusion Therapy', pending: 4, rate: 22.0 },
    { procedure: 'Physical Therapy', pending: 3, rate: 8.5 },
  ],
  expirationRisk: [
    { id: 'A001', patientName: 'Gloria Reyes', payer: 'Medicaid', procedure: 'Infusion Therapy', authExpires: '2026-04-18', daysUntilExpiry: 6, hasAppointment: false },
    { id: 'A002', patientName: 'Robert Taylor', payer: 'UnitedHealthcare', procedure: 'MRI', authExpires: '2026-04-22', daysUntilExpiry: 10, hasAppointment: false },
    { id: 'A003', patientName: 'Maria Lopez', payer: 'Aetna', procedure: 'CT Scan', authExpires: '2026-04-25', daysUntilExpiry: 13, hasAppointment: false },
  ],
  staffTimeEstimate: {
    totalHoursPerWeek: 18.5,
    avgMinutesPerAuth: 22,
    label: 'Estimated — based on auth-pending count \u00d7 average follow-up time',
  },
  trend8Week: [
    { week: 'W1', pending: 20, avgTurnaround: 8.2 }, { week: 'W2', pending: 22, avgTurnaround: 8.5 },
    { week: 'W3', pending: 24, avgTurnaround: 8.8 }, { week: 'W4', pending: 23, avgTurnaround: 9.0 },
    { week: 'W5', pending: 25, avgTurnaround: 9.2 }, { week: 'W6', pending: 26, avgTurnaround: 9.5 },
    { week: 'W7', pending: 27, avgTurnaround: 9.3 }, { week: 'W8', pending: 28, avgTurnaround: 9.6 },
  ],
};

// FSA.8 — Signal Routing Log
export const mockSignalLog = [
  { id: 'SIG-001', timestamp: '2026-04-12T08:15:00Z', sourceSignal: 'No-show rate > 10%', targetDomain: 'Quality & Regulatory', signalType: 'Access quality friction', severity: 'high' },
  { id: 'SIG-002', timestamp: '2026-04-12T08:15:00Z', sourceSignal: 'Phone abandonment > 7%', targetDomain: 'Consumer Insights', signalType: 'Patient access dissatisfaction', severity: 'high' },
  { id: 'SIG-003', timestamp: '2026-04-12T08:15:00Z', sourceSignal: 'Phone abandonment + high volume', targetDomain: 'Staffing', signalType: 'Phone staffing insufficiency', severity: 'medium' },
  { id: 'SIG-004', timestamp: '2026-04-12T08:15:00Z', sourceSignal: 'Referrals aging > 30 days (5)', targetDomain: 'Population Health', signalType: 'Care continuity friction', severity: 'high' },
  { id: 'SIG-005', timestamp: '2026-04-12T08:15:00Z', sourceSignal: 'Auth turnaround UHC > avg', targetDomain: 'Payer Ops', signalType: 'Payer friction', severity: 'medium' },
  { id: 'SIG-006', timestamp: '2026-04-11T08:15:00Z', sourceSignal: 'Unfilled slots revenue loss $5,250', targetDomain: 'Financial Tracking', signalType: 'Revenue leakage', severity: 'medium' },
  { id: 'SIG-007', timestamp: '2026-04-11T08:15:00Z', sourceSignal: 'New patient access lag > 1.5x benchmark', targetDomain: 'Quality & Regulatory', signalType: 'Access quality friction', severity: 'high' },
  { id: 'SIG-008', timestamp: '2026-04-11T08:15:00Z', sourceSignal: 'Portal adoption below baseline 2+ weeks', targetDomain: 'Consumer Insights', signalType: 'Engagement decline', severity: 'low' },
  { id: 'SIG-009', timestamp: '2026-04-10T08:15:00Z', sourceSignal: 'No-show chronic patients (3 at-risk)', targetDomain: 'Population Health', signalType: 'Care gap', severity: 'high' },
  { id: 'SIG-010', timestamp: '2026-04-10T08:15:00Z', sourceSignal: 'Auth follow-up > 18 hrs/wk', targetDomain: 'Staffing', signalType: 'Capacity signal', severity: 'medium' },
];

// Director mock data — keyed by scopeId (follows mockAccessMetrics pattern)
const directorBase = {
  overview: {
    tnaDays: 12, tnaTarget: 7,
    backlogCount: 450,
    sameDayRate: 35, sameDayTarget: 85,
    utilization: 72, utilizationTarget: 80,
    noShowRate: 12.4, noShowTarget: 10,
    cancelRate: 8.2,
    trend6Month: [
      { month: 'Nov', tna: 10, backlog: 420, sameDay: 38, utilization: 74, noShow: 10.2, cancel: 7.8 },
      { month: 'Dec', tna: 11, backlog: 430, sameDay: 36, utilization: 72, noShow: 10.8, cancel: 8.0 },
      { month: 'Jan', tna: 11, backlog: 440, sameDay: 35, utilization: 71, noShow: 11.2, cancel: 8.1 },
      { month: 'Feb', tna: 12, backlog: 445, sameDay: 34, utilization: 70, noShow: 11.8, cancel: 8.3 },
      { month: 'Mar', tna: 12, backlog: 448, sameDay: 35, utilization: 71, noShow: 12.0, cancel: 8.2 },
      { month: 'Apr', tna: 12, backlog: 450, sameDay: 35, utilization: 72, noShow: 12.4, cancel: 8.2 },
    ],
  },
  capacity: {
    sites: [
      { site: 'Main Campus', utilization: 78, providers: 4, slots: 224, filled: 175 },
      { site: 'North Clinic', utilization: 68, providers: 2, slots: 88, filled: 60 },
      { site: 'East Clinic', utilization: 50, providers: 2, slots: 112, filled: 56 },
      { site: 'Cancer Center', utilization: 70, providers: 1, slots: 40, filled: 28 },
    ],
    varianceAlert: true,
  },
  noShow: {
    sites: [
      { site: 'Main Campus', rate: 11.2, revenue: 3200 },
      { site: 'North Clinic', rate: 14.5, revenue: 2800 },
      { site: 'East Clinic', rate: 13.8, revenue: 1500 },
      { site: 'Cancer Center', rate: 9.2, revenue: 900 },
    ],
  },
  accessLag: {
    sites: [
      { site: 'Main Campus', newPatient: 16, followUp: 7, benchmark: 14 },
      { site: 'North Clinic', newPatient: 22, followUp: 10, benchmark: 14 },
      { site: 'East Clinic', newPatient: 14, followUp: 6, benchmark: 14 },
      { site: 'Cancer Center', newPatient: 18, followUp: 8, benchmark: 20 },
    ],
    referralAging: {
      sites: [
        { site: 'Main Campus', total: 22, over30: 2 },
        { site: 'North Clinic', total: 15, over30: 3 },
        { site: 'East Clinic', total: 8, over30: 0 },
        { site: 'Cancer Center', total: 4, over30: 0 },
      ],
    },
  },
  phonePortal: {
    sites: [
      { site: 'Main Campus', abandonmentRate: 7.5, portalAdoption: 38 },
      { site: 'North Clinic', abandonmentRate: 9.2, portalAdoption: 28 },
      { site: 'East Clinic', abandonmentRate: 8.8, portalAdoption: 32 },
      { site: 'Cancer Center', abandonmentRate: 5.5, portalAdoption: 45 },
    ],
  },
  priorAuth: {
    sites: [
      { site: 'Main Campus', pending: 12, pctScheduled: 9.8 },
      { site: 'North Clinic', pending: 8, pctScheduled: 13.2 },
      { site: 'East Clinic', pending: 5, pctScheduled: 10.5 },
      { site: 'Cancer Center', pending: 3, pctScheduled: 15.0 },
    ],
    payerFriction: [
      { payer: 'UnitedHealthcare', avgTurnaround: 12, pending: 10 },
      { payer: 'Humana', avgTurnaround: 14, pending: 5 },
      { payer: 'Aetna', avgTurnaround: 9, pending: 8 },
    ],
  },
};

export const mockDirectorSchedulingAccess = {
  'region-primary-care': directorBase,
  'region-specialty-care': directorBase,
  'mob-oncology': directorBase,
  'mob-cardiology': directorBase,
  'service-line-chemo': directorBase,
  'service-line-surgery': directorBase,
};
